import AsyncStorage from "@react-native-async-storage/async-storage";
import { action, makeObservable, observable } from "mobx";
import RootStore from "..";
import Mutation from "../../api/mutation";

import * as Device from 'expo-device';
import * as Notifications from "expo-notifications";
import { Platform } from "react-native";
import i18n from "../../Config/LangConfig";
import QueryToken from "../../api/queries/queryToken";
import { Presta } from "../../api/type/type";
import { t } from "i18next";
import { alertMessage } from "../../utils/Alert";

async function registerForPushNotificationsAsync(tokenUser: string) {
  const mutate = new Mutation();
  let token;

  if (Platform.OS === "android") {
    await Notifications.setNotificationChannelAsync("default", {
      name: "default",
      importance: Notifications.AndroidImportance.MAX,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: "#FF231F7C",
    });
  }

  if (Device.isDevice && Platform.OS != "web") {
    const { status: existingStatus } =
      await Notifications.getPermissionsAsync();
    let finalStatus = existingStatus;
    if (existingStatus !== "granted") {
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
    }
    if (finalStatus !== "granted") {
      alert("Failed to get push token for push notification!");
      return;
    }
    /*     token = (
          await Notifications.getExpoPushTokenAsync(
            Constants.expoConfig?.extra?.eas?.projectId
          )
        ).data; */

    token = (await Notifications.getExpoPushTokenAsync()).data;

   // console.log("token => ", token);
    try {
      await mutate.pushTokenNotif(token, "", tokenUser, i18n.language);
    } catch (err) {
      console.log(JSON.stringify(err, null, 2));
      AsyncStorage.removeItem("LoginToken");
    }
  } else {
    alert("Must use physical device for Push Notifications");
  }

  return token;
}

export default class userInfo {
  isLoggedIn: Boolean = false;
  token: string = "";
  rootStore: RootStore;
  isCustomer: Boolean = false;
  isSubcontractor: Boolean = false;

  constructor(rootStore: RootStore) {
    makeObservable(this, {
      isLoggedIn: observable,
      token: observable,
      isCustomer: observable,
      isSubcontractor: observable,

      getToken: action,
      login: action,
      logout: action,
      getRoles: action,
      loginByEmail: action,
      assignRoles: action,
    });
    this.rootStore = rootStore;
  }

  getRoles = () => {
    return [this.isCustomer, this.isSubcontractor];
  };

  getToken = () => {
    return this.token;
  };

  getStatusLogin = () => {
    return this.isLoggedIn;
  };

  loginByEmail = async (email: string, password: string) => {
    const queryToken = new QueryToken();
    try {
      console.log("login ...");
      const responseGraphql = await queryToken.LoginUser(
        email.trim(),
        password.trim()
      );
      const { response, token }: Presta = responseGraphql.data.ConnectPresta;
      if (token === "") {
        console.warn(
          "Identifiant et/ou mot de passe incorrects",
          email,
          password
        );
        alertMessage(t("LOGIN_FAILED"), t("INCORRECT_CREDENTIALS"), "danger");
      } else {
        this.login(token);
        const responseGql = await queryToken.getPrestaRoles(email);
        const isCustomer: boolean =
          responseGql?.data?.getPrestaRoles?.isCustomer;
        const isSubcontractor: boolean =
          responseGql?.data?.getPrestaRoles?.isSubcontractor;
        this.assignRoles(isCustomer, isSubcontractor);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  assignRoles = (isCustomer: boolean, isSubcontractor: boolean) => {
    this.isCustomer = isCustomer;
    this.isSubcontractor = isSubcontractor;
  };

  login = async (newToken: string) => {
    registerForPushNotificationsAsync(newToken);
    AsyncStorage.setItem("LoginToken", newToken);
    this.isLoggedIn = true;
    this.token = newToken;
  };

  logout = () => {
    AsyncStorage.removeItem("LoginToken");
    this.isLoggedIn = false;
    this.token = "";
    this.isCustomer = false;
    this.isSubcontractor = false;
  };
}
